import { render, staticRenderFns } from "./ReorderMediaTypesModal.vue?vue&type=template&id=e8da9054&lang=pug&"
import script from "./ReorderMediaTypesModal.vue?vue&type=script&lang=js&"
export * from "./ReorderMediaTypesModal.vue?vue&type=script&lang=js&"
import style0 from "./ReorderMediaTypesModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports